<template>
  <div>
    <!--<ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>-->
    <div slot="title">
      <h2>Catalogo de Leyendas de Retroalimentación</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <router-link to="/SISEVA/NuevaLeyendaRetroalimentacion">
              <input type="button" class="form-control" value="Nueva Leyenda" />
            </router-link>
          </div>
        </div>

        <div class="row" style="margin-top:50px;">
          <div class="col-9"></div>
          <div class="col-1"><span>Tipo de Leyendas :</span></div>
          <div class="col-2">
            <select class="form-control" v-model="tipoLeyenda">
              <option value="0">Genéricas</option>
              <option value="1">Específicas</option>
            </select>
          </div>
        </div>
        <div class="row" style="margin-top:20px;" v-if="tipoLeyenda == 0">
          <div class="col-12">
            <table class="table table-striped table-light table-hover" id="tablaLeyendas">
              <thead class="thead-dark">
                <tr>
                  <th>Leyenda</th>
                  <th>Descricpión de Uso</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='(leyenda,indice)  in leyendas'>
                  <td>{{leyenda.Leyenda}}</td>
                  <td>
                    <ul>
                      <li v-if="leyenda.Fortalezas">Con fortalezas</li>
                      <li v-else>Sin fortalezas</li>
                      <li v-if="leyenda.AreasDeOportunidad">Con areas de oportunidad</li>
                      <li v-else>Sin areas de oportunidad</li>
                      <li v-if="leyenda.ComentariosNegativos">Comentarios Negativos</li>
                      <li v-else>Comentarios Positivos/Neutros</li>
                    </ul>
                  </td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-edit' @click='editarLeyenda(leyenda.LeyendaRetroalimentacionGenericaId)' title="Editar Leyenda"/>
                    <i class='fa fa-trash' @click='desactivarLeyendaRetroalimentacionGenerica(leyenda.LeyendaRetroalimentacionGenericaId,indice)' title="Desactivar Leyenda" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row" style="margin-top:20px;" v-if="tipoLeyenda == 1">
          <div class="col-12">
            <table class="table table-striped table-light table-hover" id="tablaLeyendasEspecificas">
              <thead class="thead-dark">
                <tr>
                  <th>Leyenda</th>
                  <th>Categoría de Observación</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='(leyenda, indice) in leyendasEspecificas'>
                  <td>{{leyenda.Leyenda}}</td>
                  <td>
                    {{leyenda.CategoriaDeObservacion}}
                  </td>
                  <td  class='d-flex justify-content-around'>
                    <i class='fa fa-edit' @click='editarLeyenda(leyenda.LeyendaRetroalimentacionEspecificaId)' title="Editar Leyenda"/>
                    <i class='fa fa-trash' @click='desactivarLeyendaRetroalimentacionEspecifica(leyenda.LeyendaRetroalimentacionEspecificaId,indice)' title="Desactivar Leyenda"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import catalogos from '@/../static/js/catalogos'
  export default {
    data() {
      return {
        leyendas: [],
        leyendasEspecificas: [],
        tipoLeyenda: 0
      }
    },
    components: {
      ModalConfirmacion: catalogos.SISEVA.ModalConfirmacion
    },
    methods: {
       buscarLeyendas: function () { //Retorna una lista de cuestionarios en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetLeyendasRetroalimentacionGenericas, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
              this.leyendas = response.data.LeyendasRetroalimentacion//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaLeyendas', 10)
            })
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      buscarLeyendasEspecificas: function () { //Retorna una lista de cuestionarios en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetLeyendasRetroalimentacionEspecificas, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
              this.leyendasEspecificas = response.data.LeyendasRetroalimentacionEspecificas//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaLeyendas', 10)
            })
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      desactivarLeyendaRetroalimentacionGenerica: function (leyendaId, indice) { //Retorna una lista de cuestionarios en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "LeyedaRetroalimentacionGenericaId": leyendaId,
          "Activo": false
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.CambiarEstatusLeyendaRetroalimentacionGenerica, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.leyendas.splice(indice, 1);
            this.$nextTick(() => {
              PaginarTabla('tablaLeyendas', 10)
            })
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      desactivarLeyendaRetroalimentacionEspecifica: function (leyendaId, indice) { //Retorna una lista de cuestionarios en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "LeyedaRetroalimentacionEspecificaId": leyendaId,
          "Activo": false
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.CambiarEstatusLeyendaRetroalimentacionEspecifica, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.leyendasEspecificas.splice(indice, 1);
            this.$nextTick(() => {
              PaginarTabla('tablaLeyendasEspecificas', 10)
            })
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      }
      , editarLeyenda: function (idLeyenda) {
        this.$router.push({
          name: 'EditarLeyendaRetroalimentacion',
          params: { idLeyenda: idLeyenda, tipoLeyendaProp: parseInt(this.tipoLeyenda) }
        })
      }

    }, mounted: function () {
      this.buscarLeyendas();
      this.buscarLeyendasEspecificas();
    }

  }

</script>

<style>

  #fila-respuestas div {
    max-height: 0px;
    overflow: hidden;
    transition: max-height 1.5s ease;
  }

  #fila-respuestas.transition div {
    max-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Psicologia/CatalogoLeyendasRetroalimentacion.vue